//VALIDATE EMAIL ----------------------------------
/**
 * *! validate_email has unit tests.
 * If you make any changes to this method, you should run the unit tests:
 * npm test src/utest/validators_helpers.test
 */
export function validate_email(mail) {
	//removing variable usage because for some reason sometimes with valid email this function returns false during login email validation. Without this constant works normal.
	// console.warn('emailRegex.test(mail)', emailRegex.test(mail));
	// return /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/gm.test(mail); //removing limit for service provider
	return (
		/^[\x00-\x7F]+$/.test(mail) &&
		/^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]{2,63})+$/i.test(
			mail,
		)
	);
}

// const emailRegex = /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/gm;
const oldEmailValidation = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;

//VALIDATE PASSWORD FOR NOT ALLOWED SYMBOLS ----------------------------------
// https://gist.github.com/leodutra/3044325?permalink_comment_id=2664410#gistcomment-2664410
// return true if we are "Outside of Latin1 Range" without from NBSP to ÿ
// https://en.wikipedia.org/wiki/ISO/IEC_8859-1#References
// \u00a0 - \u00ff // match from NBSP to ÿ
// \u0020-\u007e match only allowed symbols
// ^ for NOT

export function validateAllowedSymbols(pass) {
	return /[^\u0020-\u007e]/g.test(pass); //match only non-Latin1 chars including from NBSP to ÿ
}

//COMPARE ----------------------------------
export function passwordCompare(pass1, pass2) {
	if (pass2) {
		if (pass1 !== pass2) {
			return true;
		}
	}
	return false;
}
//FIND THE DIFFERENCE ----------------------------------
export function findDiffinString(str1, str2) {
	let diff = '';
	if (str2)
		str2.split('').forEach(function (val, i) {
			if (val != str1.charAt(i)) diff += val;
		});
	if (str1) {
		str1.split('').forEach(function (val, i) {
			if (val != str1.charAt(i)) diff += val;
		});
	}
	return diff;
}
//VALIDATE IP -----------------------------------------
export function validate_ip(address) {
	return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
		address,
	);
}

export function validateIpWithPort(address) {
	return /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?):(6553[0-5]|655[0-2][0-9]|65[0-4][0-9][0-9]|6[0-4][0-9][0-9][0-9][0-9]|[1-5](\d){4}|[1-9](\d){0,3})$/.test(
		address,
	);
}

export function validateIpAndPort(address) {
	return /^([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})(:\d{1,5})?$/.test(
		address,
		// if something is wrong with the simple regex use this one ->  ^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:\d{1,5})?$
	);
}

export function validatePort(port) {
	return /\d{1,5}/.test(port);
}

export function isValidJSON(text) {
	if (typeof text !== 'string') {
		return false;
	}
	try {
		JSON.parse(text);
		return true;
	} catch (error) {
		return false;
	}
}

//VALIDATE BADD PAYLOAD ----------------------------------
/**
 * Validates device payload has all required fields for the badd API endpoint.
 * Required fields: category, channel, id, image, position, room_id, type
 *
 * @returns { valid: boolean, missingFields: string[] }
 */
export function validateBaddPayload(device: Record<string, any>): {
	valid: boolean;
	missingFields: string[];
} {
	const requiredFields = ['category', 'channel', 'id', 'image', 'position', 'room_id', 'type'];
	const missingFields = requiredFields.filter(
		(field) => device[field] === undefined || device[field] === null,
	);
	return {
		valid: missingFields.length === 0,
		missingFields,
	};
}
